module.exports = __webpack_public_path__ + "media/application/images/icons/innovations/time-faded-a33fa8a8ea10a9efb736381ecbda6fe2.svg";